import { GroupWidget } from '../components/Group/GroupWidget';
import { withStyles } from '@wix/native-components-infra/dist/src/HOC/withStyles/withStyles';

export default {
  component: withStyles(GroupWidget, {
    cssPath: ['viewerWidget.stylable.bundle.css', 'viewerWidget.min.css'],
  }),
};
